import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

function* getCouponList(actions) {
 
  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-coupons?page=" + actions.page
        : apiUrl + "/opa-coupons" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }   

    const response = yield call(apiCall, "get", url, requestOptions);
   
    yield put({ type: "LIST_COUPON_RESPONSE_GET", value: response });
  } catch (error) {

    yield put({ type: "LIST_COUPON_RESPONSE_GET", value: error });
  }
}

function* getCoupon(actions) {

  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-coupon/"
        : apiUrl + "/opa-coupon/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "COUPON_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "COUPON_RESPONSE_GET", value: error });
  }
}

export function* getSagaCouponList() {
  yield takeEvery("GET_LIST_COUPON", getCouponList);
}

export function* getSagaCoupon() {
  yield takeEvery("GET_COUPON", getCoupon);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
